import { SvgInline } from "../SvgInline/SvgInline";

import styles from "./progress-bar.module.scss";

function ProgressBar(props) {
  return (
    <div className={styles.progressBar}>
      <div className={styles.bar} />
      <div className={styles.steps}>
        {props.steps.map((step) => {
          if (step < props.currentStep) {
            return (
              <div
                key={step}
                className={styles.completed}
                data-trackid={`completed-step-${step}`}
              >
                <SvgInline name="icon-tick-small" />
              </div>
            );
          }
          if (step === props.currentStep && props.error) {
            return (
              <div
                key={step}
                className={styles.error}
                data-trackid={`error-step-${step}`}
              >
                <SvgInline name="icon-exclamation" />
              </div>
            );
          }
          return step === props.currentStep ? (
            <div
              key={step}
              className={styles.current}
              data-trackid={`current-step-${step}`}
            />
          ) : (
            <div
              key={step}
              className={styles.step}
              data-trackid={`step-${step}`}
            />
          );
        })}
      </div>
    </div>
  );
}

export { ProgressBar };
